import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import {RemarkListAPI} from "./../../API/Caller/RemarkAPI";
//import Sidebar from "./Common/Sidebar";
//import Header from "./Common/Header";
//import Loader from "./../Loader";
import Paginate from "./../../utils/Pagination";
import Layout from "./Layout";
import ContentLoader from "../../utils/ContentLoader";


const Remarks = () =>{

    const [remarks, setRemarks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    
    const perpagedata = 20;


    useEffect(() => {

        RemarkListAPI(setRemarks, setLoading, currentPage, perpagedata, setPageCount);

        //console.log('>>>>'+usersList);

    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    return(
    <Layout>
        <div className="content">

            <div className="row">
                <div className="col-md-12">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">Remarks</h4>
                            </div>
                            <div className="col-4 text-end">
                                <div className="head-icons">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="card crm-callers-card">
                        <div className="card-body">
                            <div className="table-responsive custom-table crm-callers-table-wrap caller-wrapper">
                                {loading ?
                                    <ContentLoader />
                                :
                                <table className="table crm-callers-table" id="faqlist">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Lead Name</th>
                                            <th>Email</th>
                                            <th>Remarks</th>
                                            <th>Remark Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                    {
                                    remarks && remarks.length > 0  ?
                                        remarks.map(remark =>
                                        (

                                            <tr key={remark.id}>
                                                <td>{remark.leaddata.name}</td>
                                                <td>{remark.leaddata.email}</td>
                                                <td>{remark.remarks}</td>
                                                <td>
                                                    {(remark.created_at !== "" && remark.created_at !== null) ?
                                                        (moment(remark.created_at).format('DD MMMM, YYYY'))
                                                    :
                                                        <>-</>
                                                    }
                                                </td>
                                            </tr>
                                        ))

                                    :

                                        <tr>
                                            <td colSpan="4">
                                                <center><p>No record found...</p></center>
                                            </td>
                                        </tr>
                                    }

                                    </tbody>
                                </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {pagecount > 1 ?
                <div className="row pagination-section">

                    <nav>
                        <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                    </nav>
                </div>
                :
                    <></>
                }
            </div>

        </div>

    </Layout>
    )
}

export default Remarks;
